import PropTypes from "prop-types";
import * as uuid from "uuid";

export const getDefaultSpecification = (quoteIndex = 0, quoteTotalPrice = "") => {
  return {
    "uuid": uuid.v4(),
    "roomIndex": quoteIndex,
    "Project Description": "",
    "Administrative Charges": "", // ?
    "Category": "",
    "Location": "",
    "Collection": "",
    "Product": "",
    "Retail Price": quoteTotalPrice,
  }
}

export const IMEFieldsObjectInterface = {
  "uuid": PropTypes.string,
  "roomIndex": PropTypes.number,
  "Project Description": PropTypes.string, // custom string (any value), up to 36 symbols
  "Administrative Charges": PropTypes.string, // ?
  "Category": PropTypes.string,
  "Location": PropTypes.string,
  "Collection": PropTypes.string,
  "Product": PropTypes.string,
  "Retail Price": PropTypes.string,
}

/**
 * @param property {string}
 * @param category {string}
 * */
export const getIMEDropdownOptions = (property, category = "") => {
  switch (property) {
    case "Category":
      // return ["Bathroom Accessibility", "Bathroom Refresh", "Bathroom Remodel", "Bathrooms", "Tubliner"] //FQ-1254
      return ["Bathroom Refresh", "Bathroom Remodel", "Bathrooms", "Tubliner"]
    case "Location":
      return ["Primary Bath", "Child's Bath", "Guest Bath", "Other"]
    case "Collection":
      return category === "Bathroom Accessibility" || category === "Bathroom Remodel"
        ? ["Partial Bath Remodel & Accessibility"]
        : ["None"]
    case "Product":
      if (category === "Bathroom Accessibility") {
        return ["Safety Tub Step", "Walk-in Tub"]
      } else if (category === "Bathroom Remodel") {
        return ["Partial Bath Remodel"]
      } else {
        return ["None"]
      }
    default:
      return ["None"]
  }
}
//        Category        |	                Location                      |      Collection                      |   Product
// Bathroom Accessibility | Primary Bath, Child's Bath, Guest Bath, Other | Partial Bath Remodel & Accessibility | Safety Tub Step, Walk-in Tub
// Bathroom Refresh       | Primary Bath, Child's Bath, Guest Bath, Other |           None                       | None
// Bathroom Remodel       | Primary Bath, Child's Bath, Guest Bath, Other | Partial Bath Remodel & Accessibility | Partial Bath Remodel
// Bathrooms              | Primary Bath, Child's Bath, Guest Bath, Other |           None                       | None
// Tubliner               | Primary Bath, Child's Bath, Guest Bath, Other |           None                       | None

export const saveIMEFieldsButtonDisabled = (newIMEFieldsValues) => {
  return newIMEFieldsValues.some(fieldsObject => {
    return !fieldsObject["Project Description"] || !fieldsObject["Category"]
      || !fieldsObject["Location"] || !fieldsObject["Collection"] || !fieldsObject["Product"]
  })
}

export const restoreIMEObjectKeys = (IMEObject) => {
  IMEObject["Administrative Charges"] = IMEObject["administrative Charges"];
  delete IMEObject["administrative Charges"];
  //
  IMEObject["Category"] = IMEObject["category"];
  delete IMEObject["category"];
  //
  IMEObject["Collection"] = IMEObject["collection"];
  delete IMEObject["collection"];
  //
  IMEObject["Location"] = IMEObject["location"];
  delete IMEObject["location"];
  //
  IMEObject["Project Description"] = IMEObject["project Description"];
  delete IMEObject["project Description"];
  //
  IMEObject["Retail Price"] = IMEObject["retail Price"];
  delete IMEObject["retail Price"];
  //
  IMEObject["Product"] = IMEObject["product"];
  delete IMEObject["product"];
  //
  return IMEObject
}
